import {
  GET_FOOD_CONFIG_REQUEST,
  GET_FOOD_CONFIG_SUCCESS,
  GET_FOOD_CONFIG_FAILURE,
  UPDATE_FOOD_CONFIG_REQUEST,
  UPDATE_FOOD_CONFIG_SUCCESS,
  UPDATE_FOOD_CONFIG_FAILURE,
} from "../actions/actionType";

const initialState = {
  loading: false,
  config: null,
  error: null,
  updating: false,
  updateSuccess: false,
};

const foodConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_FOOD_CONFIG_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_FOOD_CONFIG_SUCCESS:
      return { ...state, loading: false, config: action.payload };
    case GET_FOOD_CONFIG_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case UPDATE_FOOD_CONFIG_REQUEST:
      return { ...state, updating: true, updateSuccess: false };
    case UPDATE_FOOD_CONFIG_SUCCESS:
      return { ...state, updating: false, updateSuccess: true, config: action.payload };
    case UPDATE_FOOD_CONFIG_FAILURE:
      return { ...state, updating: false, error: action.payload };
    default:
      return state;
  }
};

export default foodConfigReducer;
